import { RecentlyViewed, RecentlyViewedDocument, RecentlyViewedQuery, RecentlyViewedQueryVariables } from '../generated/graphql';
import { graphQLService } from './graphql-service';

export class RecentlyViewedService {
  async getRecentlyViewedArea() {
    const result = await graphQLService.apolloClient.query<RecentlyViewedQuery, RecentlyViewedQueryVariables>({
      query: RecentlyViewedDocument,
      fetchPolicy: 'no-cache',
    });

    return result.data.recentlyViewed as RecentlyViewed;
  }
}

export const recentlyViewedService = new RecentlyViewedService();
